import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { Button, Alert } from 'react-bootstrap';
import { Input } from '../../common/components/formControls';
import validators from '../../common/services/validators';
import { withNamespaces } from 'react-i18next';
import FontAwesome from 'react-fontawesome';

const ClassBookingForm = ({ error, handleSubmit, pristine, submitting, t, children, centers, terms, grades }) => {

    return (
        <form onSubmit={handleSubmit} className='form-login'>
            {error && <Alert bsStyle='danger'>{error}</Alert>}
            <Field name='childId' component={Input} componentClass='select' label={t('FO_Booking_Child')} validate={validators.required}>
                {children && children.map(child => <option key={child.id} value={child.id}>{child.fullName}</option>)}
            </Field>
            <Field name='centerId' component={Input} componentClass='select' label={t('FO_Booking_Center')} validate={[validators.required]}>
                {centers && centers.map(center => <option key={center.id} value={center.id}>{center.name}</option>)}
            </Field>
            <Field name='termId' component={Input} componentClass='select' label={t('FO_Booking_Term')} validate={[validators.required]}>
                {terms && terms.map(term => <option key={term.id} value={term.id}>{term.name}</option>)}
            </Field>
            <Field name='gradeId' component={Input} componentClass='select' label={t('FO_Booking_Grade')} validate={[validators.required]}>
                {grades && grades.map(grade => <option key={grade.id} value={grade.id}>{grade.name}</option>)}
            </Field>
            <div className='form-actions'>
                <Button type='submit' disabled={submitting} className='btn btn-primary'>
                    <FontAwesome name='plus' /> {t('FO_Booking_BookClass')}
                </Button>
            </div>
        </form>
    );
};

ClassBookingForm.propTypes = {
    onSubmit: PropTypes.func.isRequired
};

export default reduxForm({ form: 'classBooking', enableReinitialize: true })(withNamespaces()(ClassBookingForm));